import PropTypes from 'prop-types';
import PricingPlansTable from './PricingPlansTable';
import withComponentName from '../../../../../../decorators/withComponentName';

export const PricingPlansColumnLayout = (props) => {
  const { activePlanTab, content, headerCells } = props;
  return (
    <PricingPlansTable
      activePlanTab={activePlanTab}
      content={content}
      headerCells={headerCells}
    />
  );
};

PricingPlansColumnLayout.defaultProps = {
  content: [],
  headerCells: [],
  activePlanTab: 'column',
};

PricingPlansColumnLayout.propTypes = {
  activePlanTab: PropTypes.string,
  headerCells: PropTypes.instanceOf(Array),
  content: PropTypes.instanceOf(Array),
};

export default withComponentName(PricingPlansColumnLayout);
